import React from 'react'

const AddProps = () => {
  return (
    <div className='props'>
      <div className='prop-type'>
        <span>Occasions</span>
      </div>
      <div className='prop-type'>
        <span>Signs</span>
      </div>
      <div className='prop-type'>
        <span>Others</span>
      </div>
    </div>
  )
}

export default AddProps